import React from 'react';
import { Link } from 'react-router-dom';

import ShowForPermission from '../ShowForPermission';
import menuItems from './menuItems';
import { dataGenerator } from '../../utils';
import './styles.scss';

export default () => {
  const generateMenuItemsElements = () => {
    const menuItemsElements = [];

    for (const item of menuItems) {
      let submenu;

      let itemPermissions = item.permission ? [item.permission] : [];

      if (item.children) {
        itemPermissions = [...itemPermissions, ...item.children.map(x => x.permission).filter(x => !!x)];

        submenu = (
          <ul className="horizontal-menu__submenu rounded">
            {item.children.map(submenuItem => (
              <ShowForPermission permission={submenuItem.permission} key={submenuItem.path}>
                <li
                  className='rounded'
                  onClick={() => {
                    localStorage.removeItem('query');
                  }}
                  
                >
                  <Link to={submenuItem.path}>{submenuItem.name}</Link>
                </li>
              </ShowForPermission>
            ))}
          </ul>
        );
      }

      var li = (
        <ShowForPermission permission={itemPermissions} key={dataGenerator.generateKey('hrm')}>
          <li
            className={`horizontal-menu__list-item rounded ${submenu && 'horizontal-menu__list-item--has-submenu'}`}
          >
            <Link to={item.path}>
              <i className={`horizontal-menu__icon ${item.icon}`}></i>
              {item.name}
            </Link>
            {submenu}
          </li>
        </ShowForPermission>
      );

      menuItemsElements.push(li);
    }

    return menuItemsElements;
  };

  return (
    <div className="horizontal-menu">
      <div className="horizontal-menu__inner container">
        <nav className="horizontal-menu__nav clearfix">
          <ul className="horizontal-menu__list">{generateMenuItemsElements()}</ul>
        </nav>
      </div>
    </div>
  );
};
